import { atom } from '@reatom/framework'

export type PnlView = 'calendar' | 'chart'

export const pnlViewAtom = atom<PnlView>('chart', 'pnlViewAtom')
